export const GroupDropdownTestIds = {
  GROUP_BUTTON: 'group-dropdown.group-button',

  getActionButtonId: id => `group-dropdown.action-${id}`,
};
